import { render, staticRenderFns } from "./AppOperate.vue?vue&type=template&id=5dd20cf0&scoped=true&"
import script from "./AppOperate.vue?vue&type=script&lang=js&"
export * from "./AppOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd20cf0",
  null
  
)

export default component.exports